import React from 'react';
import Modal from "../../components/modal/modal";
import Button from '../../components/button/button.jsx';

const TipsModal = ({onClose, user, onSetId, role}) => {

    return (
        <Modal
            title={window.L("teach.student.change")}
            // tips={window.L("teach.course.inviteToJoinTips")}
            onClose={onClose}
        >
            {user ? (
                <div style={{marginTop: "1rem"}}>
                    <p style={{backgroundColor: "#efefef", padding: "1rem"}}>
                        您当前的身份是{user.role == 1 ? '学生，切换为老师后，你将能创建自己的班级，邀请学生加入。' : '老师，切换为学生后，你将无法再创建自己的班级，已创建的班级会继续保留，但是无法再在『我的班级』中看到'}
                    </p>
                </div>
            ) : (null)}
            {role ? (
                <div style={{marginTop: "1rem"}}>
                    <p style={{backgroundColor: "#efefef", padding: "1rem 1rem 0 1rem",margin:0}}>
                    您当前的身份是学生，切换为老师后，你将能创建自己的班级，邀请学生加入。
                    </p>
                    <p style={{fontWeight:'bold',backgroundColor: "#efefef", padding: "1rem",margin:"0 0 1rem 0"}}>可前往『账号设置』页面进行身份切换。</p>
                </div>
            ) : (null)}

            <div style={{textAlign: 'center'}}>
                <Button
                    label="确认切换"
                    onClick={() => {
                        onSetId()
                    }}
                />
            </div>


        </Modal>
    );
}

export default TipsModal;